import gql from 'graphql-tag';

export default gql`
mutation ($id: String!, $version: Int!) {
    deleteEtlPackage (input: { id: $id, version: $version }) {
        __typename
        id
        name
        version
    }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/EtlPackages/DeleteMutation.js